<template>
  <div class="footer">
    <!-- Copyright 2013 - 2021 ©深圳市易仓科技有限公司. All Rights Reserved 粤ICP备13020851号 -->
    {{footData}}
  </div>
</template>

<script>
import { getBottomDate } from '@/api/login.js'
export default {
  name: 'Header',
  props: {
    msg: String
  },
  data () {
    return {
      footData: ''
    }
  },
  created () {
    if (this.$ls.get('companyMessage')) {
      this.footData = this.$ls.get('companyMessage')
    } else {
      getBottomDate().then(({ data }) => {
        this.$ls.set('companyMessage', data)
        this.footData = data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.footer{
  text-align: center;
  color:rgba(153,153,153,1);
  font-size: 12px;
  line-height: 40px;
  position: relative;
  background: transparent;
}
</style>
